// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../bos/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../bos/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RadioButtonStyle input[type=radio] {
  height: 1.2rem;
  width: 1.2rem;
  margin-right: 0.4rem;
  vertical-align: middle;
}
.RadioButtonStyle p {
  font-size: 14px;
}
.RadioButtonStyle:hover {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./../gui/src/components/StylesGuide/Buttons/RadioButton/RadioButton.scss"],"names":[],"mappings":"AAGI;EACI,cAAA;EACA,aAAA;EACA,oBAAA;EAEA,sBAAA;AAHR;AAKI;EACI,eAAA;AAHR;AAKI;EACI,eAAA;AAHR","sourcesContent":[".RadioButtonStyle {\n    // display: flex;\n    // align-items: center;\n    input[type=\"radio\"] {\n        height: 1.2rem;\n        width: 1.2rem;\n        margin-right: 0.4rem;\n        // margin-top: 10px;\n        vertical-align: middle;\n    }\n    p {\n        font-size: 14px;\n    }\n    &:hover {\n        cursor: pointer;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
